<template>
    <div class="payment_loader">
        <h2>{{str.title}}</h2>
        <p>{{str.description}}</p>
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</template>

<script>
import strings from '../strings/PaymentLoader'
export default {
  name: 'PaymentLoader',
  computed: {
    str: function () {
      const lang = this.$store.state.user.language
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][lang]
        }
      }, {})
    }
  }
}
</script>

<style scoped lang="scss">
    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            transform: scale(0);
        } 40% {
              transform: scale(1.0);
          }
    }
    .payment_loader {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background: rgba(255,255,255,0.9);
        padding: 96px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        pointer-events: none;
        h2 {
        }
        p {
            margin: 0;
        }
        .spinner {
            margin: 48px auto 0;
            width: 84px;
            text-align: center;
            div {
                width: 24px;
                height: 24px;
                margin: 0 2px;
                background-color: #333;
                border-radius: 100%;
                display: inline-block;
                animation: sk-bouncedelay 1.4s infinite ease-in-out both;
                &.bounce1 {
                    animation-delay: -0.32s;
                }
                &.bounce2 {
                    animation-delay: -0.16s;
                }
            }
        }
    }
</style>
